import {PitFilterTreeNode} from "../pit-shared/domain/filter-tree/pit-filter-tree-node";
import {DxObjectMapper} from "../dx-core/services/dx-object-mapper.service";
import {PitActivityGridRow} from "./domain/pit-activity-grid-row";
import {DxFakeDataGenerator} from "../dx-in-memory-backend/services/dx-fake-data-generator";
import {PitFilteringAttribute} from "../pit-shared/domain/filter-tree/pit-filtering-attribute";
import {PitFilterValue} from "../pit-shared/domain/filter-tree/pit-filter-value";
import {PitReportsTreeNode} from "../pit-reporting/domain/pit-reports-tree-node";
import {PitNciRegistryTreeNode} from "../pit-nci/domain/pit-nci-registry-tree-node";

/** Провайдер моков для модуля "Мероприятия" */
export class PitActivitiesMocksProvider {

  public static provideActivitiesFilterTreeMocks(): Object[] {
    const docNodes: PitFilterTreeNode[] = [];

    let node: PitFilterTreeNode = new PitFilterTreeNode();
    node.id = 1;
    node.parentId = null;
    node.ord = 1;
    node.title = 'Все мероприятия';
    node.ident = 'PIT_ALL_ACTIVITIES_FOLDER';
    node.type = 'FOLDER';
    node.description = 'Все мероприятия';
    docNodes.push(node);


    node = new PitFilterTreeNode();
    node.id = 4;
    node.parentId = 1;
    node.ord = 1;
    node.title = 'План мероприятий ИКТ';
    node.ident = 'PIT_IKR_ACTIVITIES_FOLDER';
    node.type = 'FOLDER';
    node.description = 'План мероприятий ИКТ';
    docNodes.push(node);

    node = new PitFilterTreeNode();
    node.id = 12;
    node.parentId = 4;
    node.ord = 1;
    node.title = 'Мероприятий ИКТ на 2019-2021 гг.';
    node.ident = 'PIT_IKR_ACTIVITIES_FIRST_STAGE';
    node.type = 'DOCUMENT';
    node.description = 'Мероприятий ИКТ на 2019-2021 гг.';
    // node.attributes = PitActivitiesMocksProvider.prepareFilteringAttrs();
    docNodes.push(node);

/*
    node = new PitFilterTreeNode();
    node.id = 13;
    node.parentId = 4;
    node.ord = 1;
    node.title = 'Мероприятий ИКТ второй очереди';
    node.ident = 'PIT_IKR_ACTIVITIES_SECOND_STAGE';
    node.type = 'DOCUMENT';
    node.description = 'Большое длинное, очень развернутое описание документа';
    node.attributes = PitActivitiesMocksProvider.prepareFilteringAttrs();
    docNodes.push(node);
*/


    node = new PitFilterTreeNode();
    node.id = 5;
    node.parentId = 1;
    node.ord = 2;
    node.title = 'Дополнительные мероприятия';
    node.ident = 'PIT_IKR_ACTIVITIES_FOLDER';
    node.type = 'FOLDER';
    node.description = 'Дополнительные мероприятия';
    node.attributes = PitActivitiesMocksProvider.prepareFilteringAttrs();
    docNodes.push(node);



    node = new PitFilterTreeNode();
    node.id = 6;
    node.parentId = 1;
    node.ord = 3;
    node.title = 'Отклоненные мероприятия';
    node.ident = 'PIT_DEFERRED_ACTIVITIES_FOLDER';
    node.type = 'FOLDER';
    node.description = 'Отклоненные мероприятия';
    node.attributes = PitActivitiesMocksProvider.prepareFilteringAttrs();

    docNodes.push(node);

    node = new PitFilterTreeNode();
    node.id = 10;
    node.parentId = 6;
    node.ord = 1;
    node.title = 'Остановлено финансирование';
    node.ident = 'PIT_ACTIVITIES_FINANCING_STOPPED';
    node.type = 'DOCUMENT';
    node.description = 'Остановлено финансирование';
    node.attributes = PitActivitiesMocksProvider.prepareFilteringAttrs();
    docNodes.push(node);

    node = new PitFilterTreeNode();
    node.id = 11;
    node.parentId = 6;
    node.ord = 2;
    node.title = 'Не актуальные';
    node.ident = 'PIT_ACTIVITIES_NON_ACTUAL';
    node.type = 'DOCUMENT';
    node.description = 'Большое длинное, очень развернутое описание документа';
    node.attributes = PitActivitiesMocksProvider.prepareFilteringAttrs();
    docNodes.push(node);



/*
    node = new PitFilterTreeNode();
    node.id = 7;
    node.parentId = 1;
    node.ord = 4;
    node.title = 'Планы на будущее';
    node.ident = 'PIT_FUTURE_ACTIVITIES_FOLDER';
    node.type = 'FOLDER';
    node.description = 'Большое длинное, очень развернутое описание папки';
    docNodes.push(node);

    node = new PitFilterTreeNode();
    node.id = 8;
    node.parentId = 7;
    node.ord = 1;
    node.title = 'Мероприятия на 2020';
    node.ident = 'PIT_ACTIVITIES_2020';
    node.type = 'DOCUMENT';
    node.description = 'Большое длинное, очень развернутое описание документа';
    node.attributes = PitActivitiesMocksProvider.prepareFilteringAttrs();
    docNodes.push(node);

    node = new PitFilterTreeNode();
    node.id = 9;
    node.parentId = 7;
    node.ord = 2;
    node.title = 'Мероприятия на 2021';
    node.ident = 'PIT_ACTIVITIES_2021';
    node.type = 'DOCUMENT';
    node.description = 'Большое длинное, очень развернутое описание документа';
    node.attributes = PitActivitiesMocksProvider.prepareFilteringAttrs();
    docNodes.push(node);




    node = new PitFilterTreeNode();
    node.id = 2;
    node.parentId = null;
    node.ord = 2;
    node.title = 'Включенные в план';
    node.ident = 'PIT_ACTIVITIES_IN_PLAN';
    node.type = 'DOCUMENT';
    node.description = 'Большое длинное, очень развернутое описание документа';
    node.attributes = PitActivitiesMocksProvider.prepareFilteringAttrs();
    docNodes.push(node);

    node = new PitFilterTreeNode();
    node.id = 3;
    node.parentId = null;
    node.ord = 3;
    node.title = 'На рассмотрении';
    node.ident = 'PIT_ACTIVITIES_UNDER_CONSIDERATION';
    node.type = 'DOCUMENT';
    node.description = 'Большое длинное, очень развернутое описание документа';
    node.attributes = PitActivitiesMocksProvider.prepareFilteringAttrs();
    docNodes.push(node);
*/

    return DxObjectMapper.toPlainArray(docNodes, PitFilterTreeNode);
  }

  public static prepareFilteringAttrs(): PitFilteringAttribute[] {
    let attr: PitFilteringAttribute;
    let value: PitFilterValue;
    const attributes: PitFilteringAttribute[] = [];

    // attr = new PitFilteringAttribute();
    // attr.id = 1;
    // attr.ident = 'type';
    // attr.values = [];
    //
    // value = new PitFilterValue();
    // value.valueInt = DxFakeDataGenerator.getRandomInt(1, 5);
    // attr.values.push(value);
    //
    // attributes.push(attr);


    attr = new PitFilteringAttribute();
    attr.id = 2;
    attr.ident = 'fundsAdditionType';
    attr.values = [];

    value = new PitFilterValue();
    value.valueInt = DxFakeDataGenerator.getRandomInt(1, 3);
    attr.values.push(value);

    attributes.push(attr);

    return attributes;
  }


  public static provideActivitiesGridDataMocks(): Object[] {
    const activities: PitActivityGridRow[] = [];
    const count: number = 1000;

    let activity: PitActivityGridRow;
    for (let i = 0; i < count; i++) {
      activity = new PitActivityGridRow();
      activity.id = DxFakeDataGenerator.getRandomId();
      activity.code = 'М' + DxFakeDataGenerator.getRandomAccount();
      activity.name = 'Мероприятие ' + activity.code;
      activity.type = DxFakeDataGenerator.getRandomInt(1, 5);
      activity.firstPeriodAmount = DxFakeDataGenerator.getRandomAmount(0, 100000);
      activity.secondPeriodAmount = DxFakeDataGenerator.getRandomAmount(0, 100000);
      activity.thirdPeriodAmount = DxFakeDataGenerator.getRandomAmount(0, 100000);
      activity.totalAmount = activity.firstPeriodAmount + activity.secondPeriodAmount + activity.thirdPeriodAmount;
      activity.stateProgramId = DxFakeDataGenerator.getRandomInt(1, 10);
      activities.push(activity);
    }
    return DxObjectMapper.toPlainArray(activities, PitActivityGridRow);
  }

  public static provideReportsTreeMocks(): Object[] {
    const docNodes: PitReportsTreeNode[] = [];
    let node: PitReportsTreeNode;


    node = new PitReportsTreeNode();
    node.id = 1;
    node.parentId = null;
    node.ord = 1;
    node.title = 'OLAP по лимитам';
    node.ident = 'PIT_OLAP_BY_LIMITS_FOLDER';
    node.type = 'FOLDER';
    docNodes.push(node);

    node = new PitReportsTreeNode();
    node.id = 2;
    node.parentId = 1;
    node.ord = 1;
    node.title = 'Аналитика по бюджетополучателям';
    node.ident = 'PIT_BUDGET_RECEIVERS_REPORT';
    node.type = 'DOCUMENT';
    node.link = ':home:admin:Limits:LimitsByContractor.saiku';
    docNodes.push(node);

    node = new PitReportsTreeNode();
    node.id = 3;
    node.parentId = 1;
    node.ord = 2;
    node.title = 'Аналитика по статьям финансирования';
    node.ident = 'PIT_FINANCINGS_REPORT';
    node.type = 'DOCUMENT';
    node.link = ':home:admin:Limits:LimitsByKbk.saiku';
    docNodes.push(node);



    node = new PitReportsTreeNode();
    node.id = 10;
    node.parentId = null;
    node.ord = 2;
    node.title = 'OLAP по плану мероприятий';
    node.ident = 'PIT_OLAP_BY_PLAN_FOLDER';
    node.type = 'FOLDER';
    docNodes.push(node);

    node = new PitReportsTreeNode();
    node.id = 11;
    node.parentId = 10;
    node.ord = 1;
    node.title = 'Текущий план ИТ мероприятий';
    node.ident = 'PIT_PLAN_1';
    node.type = 'DOCUMENT';
    node.link = ':home:admin:Activities:CurrencyPlan.saiku';
    docNodes.push(node);

    node = new PitReportsTreeNode();
    node.id = 12;
    node.parentId = 10;
    node.ord = 1;
    node.title = 'Аналитика Блок-подблок';
    node.ident = 'PIT_PLAN_2';
    node.type = 'DOCUMENT';
    node.link = ':home:admin:Activities:BlockAnalit.saiku';
    docNodes.push(node);

    node = new PitReportsTreeNode();
    node.id = 13;
    node.parentId = 10;
    node.ord = 1;
    node.title = 'Аналитика по гос.заказчикам';
    node.ident = 'PIT_PLAN_3';
    node.type = 'DOCUMENT';
    node.link = ':home:admin:Activities:ContractorAnalit.saiku';
    docNodes.push(node);

    node = new PitReportsTreeNode();
    node.id = 14;
    node.parentId = 10;
    node.ord = 1;
    node.title = 'Сравнение версия плана';
    node.ident = 'PIT_PLAN_4';
    node.type = 'DOCUMENT';
    node.link = ':home:admin:Activities:ActivityByPlanVersion.saiku';
    docNodes.push(node);



    node = new PitReportsTreeNode();
    node.id = 30;
    node.parentId = null;
    node.ord = 4;
    node.title = 'Отчеты о процессе';
    node.ident = 'PIT_PROCESS_REPORTS_FOLDER';
    node.type = 'FOLDER';
    node.link = '';
    docNodes.push(node);

    node = new PitReportsTreeNode();
    node.id = 31;
    node.parentId = 30;
    node.ord = 1;
    node.title = 'Отчет о процессах';
    node.ident = 'PIT_PROCESS_REPORT';
    node.type = 'DOCUMENT';
    node.link = ':home:admin:ProcessReport.wcdf';
    docNodes.push(node);


    return DxObjectMapper.toPlainArray(docNodes, PitReportsTreeNode);
  }




}
